<template>
  <div class="invoice-wrap-bg">
    <EditCorrectionForm
      ref="correction-edit-form"
      emit-submit
      is-edit
      @updated="correctionUpdated"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import EditCorrectionForm from "@/components/invoices/EditCorrectionForm"
export default {
  name: 'EditCorrectionView',
  components: {
    EditCorrectionForm,
  },
  props: {

  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      invoice: 'invoices/getInvoice',
      getCompanyId: 'main/getCompanyId'
    }),
  },
  created () {
    this.$emit('display-buttons', 'create')
  },
  methods: {
    ...mapActions ({
      loadInvoice: 'invoices/loadInvoice',
      loadCorrectionFiles: 'invoices/loadCorrectionFiles'
    }),
    correctionUpdated () {
      // console.log('loadInvoice from EditCorrectionView::correctionUpdated')
      // this.loadInvoice(this.invoice.id).then(() => {
      //   this.loadCorrectionFiles(this.invoice.correction.id).then(() => {
      //     this.$router.push({ name: 'InvoiceView', params: { invoiceId: this.invoice.id } }).catch(() => {})
      //   })
      // })
      
      if (this.$route.path.includes('control-panel')) {
        this.$router.push({ name: 'ControlPanelInvoiceEdit', params: { customerId: this.getCompanyId, invoiceId: this.invoice.id } }).catch(() => {})
      } else {
        this.$router.push({ name: 'InvoiceView', params: { invoiceId: this.invoice.id } }).catch(() => {})
      }
      this.$emit('correction-updated')
    },
    saveCorrection () {
      this.$refs['correction-edit-form'].onSubmit()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>